(() => {
  if (window.dervoStoreLoaded) return;
  window.dervoStoreLoaded = true;
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-ds-sort]')) return;
    const url = new URL(location.href);
    url.searchParams.set('sort_by', event.target.value);
    url.searchParams.delete('page');
    location.assign(url.href);
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-ds-expand]');
    if (!button) return;
    const open = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', String(open));
    button.closest('[data-ds-collapse]').classList.toggle('is-open', open);
    const label = button.querySelector('[data-collapse-label]');
    if (label) label.textContent = open ? button.dataset.close : button.dataset.open;
    else button.textContent = (open ? button.dataset.close : button.dataset.open) + (open ? ' ⌃' : ' ⌄');
  });
  function init(root = document) {
    root.querySelectorAll('.ds-filter-shell').forEach(el => {
      if (el.dataset.initialized) return;
      el.dataset.initialized = 'true';
      const mobile=matchMedia('(max-width:749px)');
      el.open = !mobile.matches;
      mobile.addEventListener('change',()=>{if(el.isConnected)el.open=!mobile.matches;});
    });
  }
  document.addEventListener('keydown',event=>{if(event.key==='Escape'&&matchMedia('(max-width:749px)').matches)document.querySelectorAll('.ds-filter-shell[open]').forEach(el=>el.open=false);});
  init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
(() => {
  if(window.dervoCartLoaded)return;window.dervoCartLoaded=true;
  const root = () => window.Shopify?.routes?.root || '/';
  let opener, busy = false;
  window.dervoOpenCart = async ({open = true} = {}) => {
    const old = document.getElementById('DervoMiniCart');
    if (!old) return false;
    const response = await fetch(root() + '?section_id=' + encodeURIComponent(old.dataset.sectionId), {cache:'no-store'});
    if (!response.ok) return false;
    const next = new DOMParser().parseFromString(await response.text(),'text/html').querySelector('#DervoMiniCart');
    if (!next) return false;
    old.querySelector('[data-ds-cart-content]').replaceWith(next.querySelector('[data-ds-cart-content]'));
    old.querySelector('#MiniCartTitle').textContent = next.querySelector('#MiniCartTitle').textContent;
    document.querySelectorAll('[data-dh-cart-count]').forEach(el=>{el.textContent=next.dataset.itemCount;el.hidden=Number(next.dataset.itemCount)===0;});
    old.dataset.itemCount=next.dataset.itemCount;
    document.dispatchEvent(new CustomEvent('dervo:cart:render',{detail:{dialog:old}}));
    if (open && !old.open) { opener = document.activeElement; old.showModal(); }
    return true;
  };
  document.addEventListener('click', async event => {
    const close = event.target.closest('[data-ds-cart-close]');
    if (close) { close.closest('dialog').close(); opener?.focus(); return; }
    const link = event.target.closest('.dh-cart');
    if (link && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
      event.preventDefault();
      try { if (!await window.dervoOpenCart()) location.assign(link.href); }
      catch { location.assign(link.href); }
    }
    const step = event.target.closest('[data-ds-cart-step]');
    if (step) { const input = step.parentElement.querySelector('[data-ds-cart-qty]'); const next = Number(input.value) + Number(step.dataset.dsCartStep) * Number(input.step || 1); if(next >= Number(input.min) && (!input.max || next <= Number(input.max))) change(input.dataset.key,next); }
    const remove = event.target.closest('[data-ds-cart-remove]');
    if (remove) change(remove.dataset.key,0);
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-ds-cart-qty]') && event.target.reportValidity()) change(event.target.dataset.key,Number(event.target.value));
  });
  async function change(id,quantity) {
    if (busy) return;
    busy = true;const dialog=document.getElementById('DervoMiniCart');dialog.setAttribute('aria-busy','true');
    dialog.querySelectorAll('button:not([data-ds-cart-close]),input').forEach(el=>{el.dataset.wasDisabled=String(el.disabled);el.disabled=true;});
    try {
      const response=await fetch(root()+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id,quantity})});
      const data=await response.json();if (!response.ok) throw new Error(data.description||data.message||'De hoeveelheid kon niet worden aangepast.');
      document.querySelectorAll('[data-dh-cart-count]').forEach(el=>{el.textContent=data.item_count;el.hidden=data.item_count===0;});
      if(!await window.dervoOpenCart({open:dialog.open}))throw new Error('De winkelwagen is aangepast, maar kon niet worden vernieuwd. Open de winkelwagenpagina.');
    } catch(error) {const el=dialog.querySelector('[data-ds-cart-error]');if(el){el.hidden=false;el.textContent=error.message;}}
    finally {busy=false;dialog.removeAttribute('aria-busy');dialog.querySelectorAll('[data-was-disabled]').forEach(el=>{el.disabled=el.dataset.wasDisabled==='true';delete el.dataset.wasDisabled;});}
  }
})();
